import { useState} from 'react';
import '../Card/Card.scss'
// import Button from "../../../Button";
import Modal from "../../../Modal";
import ButtonCart from '../../../ButtonCart/ButtonCart';
import { Button } from '@mui/material';

const Card = ({isCardInCart,isCardInFavourite,removeFromCart,addToCart,product,removeFromFavourite,addToFavourite})=>{

    const[modalCart,setModalCart] = useState(false)
   
    
    const showCartModal =()=>{
        setModalCart(true)
        
    }
   const closeCartModal =()=>{
    setModalCart(false)
    }

const addCart = () =>{
    if(isCardInCart){
        removeFromCart(product)
    }else{
        addToCart(product)
        setModalCart(false)
        }
    }

 const addFavourite = () =>{
    if(isCardInFavourite){
        removeFromFavourite(product)
    }else{
        addToFavourite(product)
    }
    
 }
    const url = product.url;
    const id = product.id
    const title = product.title
    const color = product.color
    const price = product.price
   
    const actionsModalCart =
        <div style={{display: 'flex'}}>
          <ButtonCart  onClick={addCart}/>
          <Button color="primary" variant="contained" style={{marginLeft: '10px'}} onClick={closeCartModal}>cancel</Button> 
          </div>

return(
    <>
 <div className="card">
                <div className="card__header">
                    <img className="card__header-img" src={url} alt="img" />
                    <div className="favourite__icon-wrapper" onClick={addFavourite}>
                        
                        <img className="favourite__icon" 
                            src={isCardInFavourite ?'/img/star-ischanged.png' :'/img/star.png'  } 
                             alt="star" 
                            />
                        
                    </div>
                    
                </div>
                <div className="card__content">
                    <p className="card__content-title">{title}</p>
                    <p className="card__content-color">Color: {color}</p>
                    <p className="card__content-article">Product id: {id}</p>

                </div>
                <div className="card__footer">
                    <p className="card__footer-price">{price}$</p>
                    <ButtonCart onClick={showCartModal}/>
                </div>
               
            </div>
            {modalCart &&
                        <Modal
                            header='Do you want to add this product to the cart?'
                            text='This product will be added to the cart!'
                            btnClose={closeCartModal}
                            actions={actionsModalCart}
                        />
                    
                    }
    </>
)
}

export default Card;

